import { useAuth } from "./authorization";

export function useHasScope(required: string | string[], any = false): boolean {
  const { user } = useAuth();
  const scopes = user?.scopes ?? [];

  const requiredList = Array.isArray(required) ? required : [required];

  if (scopes.includes('*')) return true;

  if (any) {
    return requiredList.some(scope => scopes.includes(scope));
  }

  return requiredList.every(scope => scopes.includes(scope));
}

export function useHasAllStoresAccess(): boolean {
  const { user } = useAuth();
  const stores = user?.stores ?? [];

  return stores.length === 0 || Number(stores[0]) === 0;
}
